// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#0033ad","customColor7":"#4dd4ff"};